module.exports = __webpack_public_path__ + "static/Theo_Rougier-c2895e1a850ce097aa6ed36d4230437f.webp";